import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import selector from 'redux_store/selectors/tenderCard/participants';
import { getPostfixProURL } from 'utils/commonFunc';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import {
  changeParticipantsEdit,
  deleteParticipant,
  AddParticipant,
  ReplaceParticipantsFromDefault,
} from 'redux_store/modules/tenderCard';
import { notWinnerImg as NotWinnerImg, winnerImg as WinnerImg, cogImg, trashImg } from 'theme/icon';

import RowEdit from './control/editRow';
import SelectFirm from './control/selectFirm';

import styles from './styles.scss';

@connect(selector, {
  changeParticipantsEdit,
  deleteParticipant,
  AddParticipant,
  ReplaceParticipantsFromDefault,
})
export default class TenderParticipants extends React.PureComponent {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    dictionary: PropTypes.objectOf(PropTypes.any).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    statistic: PropTypes.objectOf(PropTypes.any).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    items: PropTypes.arrayOf(PropTypes.object),
    changeParticipantsEdit: PropTypes.func.isRequired,
    deleteParticipant: PropTypes.func.isRequired,
    AddParticipant: PropTypes.func.isRequired,
    ReplaceParticipantsFromDefault: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    tenderData: PropTypes.objectOf(PropTypes.any).isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    access: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  static defaultProps = { items: [] };

  constructor(props) {
    super(props);
    this.grid = React.createRef();
  }

  // eslint-disable-next-line class-methods-use-this
  openLink = url => {
    const win = window.open(url, '_blank');
    win.focus();
  };
  clickStatistic = (typeId, url) =>
    typeId === 1 ? window.scrollTo(0, this.grid.current.offsetTop) : this.openLink(url);

  render() {
    const {
      items,
      dictionary,
      tenderData,
      statistic: { typeStatistic, winners, count, allow },
      access,
    } = this.props;
    const { currency, currencySymbol } = dictionary;
    let url = null;
    if (winners && winners[0]) {
      url = `https://pro.myseldon.com/ru/tender/${tenderData.lotId}-${getPostfixProURL(
        tenderData.purchaseType ? tenderData.purchaseType.id : '1',
      )}`;
    }
    return (
      <div className={styles.wrapper}>
        {count > 0 && (
          <div className={styles.top}>
            <div className={styles.statistic}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <div>
                Подали заявку - {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => this.clickStatistic(typeStatistic, url)}>{count}</a>. Из них допущено -{' '}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => this.clickStatistic(typeStatistic, url)}>{allow}</a>.{' '}
                {winners.length === 0 && <span>Победитель не определён</span>}
                {winners.length > 0 && winners[0].ogrn === null && <span>Победителем стал {winners[0].name}</span>}
                {winners.length > 0 && winners[0].ogrn !== null && (
                  <span>
                    Победителем стал{' '}
                    <a
                      href={`https://basis.myseldon.com/ru/company/${winners[0].ogrn}`}
                      target="_blank"
                      // onClick={() => this.clickStatistic(typeStatistic, url)}
                    >
                      {winners[0].name}
                    </a>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a onClick={() => this.clickStatistic(typeStatistic, url)}>
                      {winners.length > 1 && <span> ({winners.length})</span>}
                    </a>
                  </span>
                )}
              </div>
              <div>Количество заключенных контрактов: {tenderData.contract_count || 'Контракт ещё не заключен'}</div>
            </div>
          </div>
        )}
        <div className={styles.body} ref={this.grid}>
          <div className={styles.header}>
            Участники тендера <span>{items.length}</span>
          </div>
          <div className={styles.selectFirmBlock}>
            <SelectFirm
              isParticipantsActive={access.isParticipantsActive}
              saveFirm={async firm => {
                let picture = null;
                if (firm.ogrn) {
                  const res = await axios.post('/api/firm/basis/ogrn/', {
                    ogrnList: [Number(firm.ogrn)],
                  });
                  const stringOGRN = String(firm.ogrn);
                  if (res && res.data && res.data[stringOGRN]) {
                    picture = res.data[stringOGRN].Picture;
                  }
                }
                this.props.AddParticipant({
                  id: -new Date().getTime(),
                  firmId: firm.id || null,
                  name: firm.label,
                  ogrn: firm.ogrn,
                  inn: firm.inn,
                  kpp: firm.kpp,
                  firmTypeId: firm.firmTypeId,
                  winner: false,
                  refuseContract: false,
                  price: 0,
                  currencyId: 12000,
                  allowed: true,
                  edit: true,
                  picture,
                });
              }}
            />
            {access.fillingProtocol && (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a onClick={() => this.props.ReplaceParticipantsFromDefault()}>Загрузить компании из протокола</a>
            )}
          </div>
          <div className={styles.list}>
            {items.map(row => {
              const cur = currency.find(c => c.id === row.currencyId);
              const AllowImg = row.allowed ? (
                <CheckCircleOutlined style={{ color: 'green' }} />
              ) : (
                <CloseCircleOutlined style={{ color: 'red' }} />
              );
              return (
                <div key={row.id} className={styles.item}>
                  <div className={styles.image}>
                    <img alt="" src={row.picture} />
                  </div>
                  <div className={styles.itemCaption}>
                    {row.ogrn && (
                      <a
                        href={`https://basis.myseldon.com/ru/company/${row.ogrn}`}
                        target="_blank"
                        className={styles.itemName}
                      >
                        {row.name}
                      </a>
                    )}
                    {row.ogrn == null && <div className={styles.itemName}>{row.name}</div>}
                    <div className={styles.blockAttr}>
                      <div className={styles.attr}>
                        <div className={styles.name}>ИНН:</div>
                        <div className={styles.caption}>{row.inn}</div>
                      </div>
                      {row.kpp && (
                        <div className={styles.attr}>
                          <div className={styles.name}>КПП:</div>
                          <div className={styles.caption}>{row.kpp}</div>
                        </div>
                      )}
                      {row.firmId && (
                        <div className={styles.attr}>
                          <div className={styles.name}>{row.firmTypeId === 1 ? 'Филиал' : 'Физическое лицо'}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  {(row.edit === undefined || !row.edit) && [
                    <div key={`icons-${row.id}`} className={styles.icons}>
                      {row.winner && !row.refuseContract && (
                        <div className={styles.icon}>
                          <WinnerImg alt="" />
                          <span className={styles.caption}>Победитель</span>
                        </div>
                      )}
                      {row.winner && row.refuseContract && (
                        <div className={styles.icon}>
                          <NotWinnerImg alt="" />
                        </div>
                      )}
                      {row.refuseContract && (
                        <div className={styles.icon}>
                          <ExclamationCircleOutlined style={{ color: 'red' }} />
                          <span className={styles.caption}>Отказ от контракта</span>
                        </div>
                      )}
                    </div>,
                    <div key={`price-${row.id}`} className={styles.price}>
                      <div className={styles.priceValue}>
                        {row.price != null &&
                          row.price >= 0 && [
                            <NumberFormat
                              value={row.price}
                              displayType="text"
                              thousandSeparator=" "
                              decimalSeparator=","
                              decimalprecision={2}
                              key={`${row.id}-price`}
                              // suffix={` ${String.fromCharCode(row.currency.symbol)}`}
                            />,
                            <span key={`${row.id}-currency`} className={styles.currency}>
                              {cur && String.fromCharCode(cur.symbol)}
                            </span>,
                          ]}
                      </div>
                      {row.dif && (
                        <div className={row.dif.indexOf('-') !== -1 ? styles.priceDifMinus : styles.priceDifPlus}>
                          <div />
                          {row.dif}%
                        </div>
                      )}
                    </div>,
                    <div key={`status-${row.id}`} className={styles.status}>
                      {row.allowed != null && (
                        <div className={styles.icon}>
                          {AllowImg}
                          <span className={styles.caption}>{row.allowed ? 'Допущен' : 'Не допущен'}</span>
                        </div>
                      )}
                    </div>,
                    <div key={`buttons-${row.id}`} className={styles.buttons}>
                      <div onClick={() => this.props.changeParticipantsEdit(row.id, true)}>
                        <img alt="" src={cogImg} />
                      </div>
                      <div onClick={() => this.props.deleteParticipant(row.id)}>
                        <img alt="" src={trashImg} />
                      </div>
                    </div>,
                  ]}
                  {row.edit && (
                    <RowEdit
                      form={`edit-form-${row.id}`}
                      initialValues={row}
                      currency={currencySymbol}
                      onRequestClose={() => this.props.changeParticipantsEdit(row.id, false)}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
